/**
 * <TutorCoachingVideosPage> — « Vidéos coaching » : les vidéos de formation du masteur (page).
 *
 * L'ancien `TutorVideos` (route `videos-coaching`, « Formation du tuteur » dans les ressources) :
 * une ligne, « Formation du tuteur », qui ouvre « Ta formation » (`<TutorTrainingPage>`) — la vidéo
 * se joue dans l'app, avec le quiz après. C'est par ici qu'un tuteur actif, qui n'a plus la carte
 * de l'accueil, garde la vidéo.
 *
 * La branche « Le coaching » de l'ancien écran (deux vidéos YouTube) n'est plus atteignable : plus
 * rien n'ouvre cette route avec `coaching: true`. Elle n'est pas portée (`parite-tuteur/compte.md`).
 */
import React from "react"

import { IconButton } from "../../atoms/Buttons/IconButton"
import { Header } from "../../molecules/Header"
import { SettingsSection } from "../../molecules/SettingsSection"
import { PageTemplate } from "../../templates/PageTemplate"

export type TutorCoachingVideosPageProps = {
    onBack: () => void
    /** « Formation du tuteur » : ouvre « Ta formation ». */
    onOpenTraining: () => void
    testID?: string
}

const VIDEOS_WIDTH = 720

export function TutorCoachingVideosPage(props: TutorCoachingVideosPageProps) {
    const { onBack, onOpenTraining, testID } = props

    const header = (
        <Header
            title="Vidéos de formation"
            left={
                <IconButton
                    iconName="chevron-left"
                    appearance="transparent"
                    iconColor="primary"
                    onPress={onBack}
                    accessibilityLabel="Retour"
                />
            }
        />
    )

    return (
        <PageTemplate testID={testID} header={header} padding="4" maxContentWidth={VIDEOS_WIDTH}>
            <SettingsSection
                rows={[
                    {
                        key: "training",
                        iconName: "play",
                        label: "Formation du tuteur",
                        onPress: onOpenTraining,
                    },
                ]}
            />
        </PageTemplate>
    )
}
